import apiCheckout from '@/api/checkout';

const goodies = {
    strict: true,
    namespaced: true,
    state: {
        showProductsModal: false
    },
    mutations: {
        showProductsModal(state, payload) { 
            state.showProductsModal = payload;
        },
    },
    actions: {
        // state, commit, dispatch, rootState, rootGetters
        async removeAll(context, payload, dispatch, rootState, rootGetters){
            //console.log('goodies store module ', context, payload);
            context.commit('isLoading', true, { root: true }); // commit for root module

            const {data} = await apiCheckout.removeGoodies();
            //console.log('apiCheckout.removeGoodies data', data);
            if(data.hasOwnProperty('cart')){
                // commit new cart data (root module)
                context.commit('cart', data.cart, { root: true });
            }
            // change loading state
            context.commit('isLoading', false, { root: true });
        },
        async add(context, payload, dispatch, rootState, rootGetters){
            context.commit('isLoading', true, { root: true }); // commit for root module
            const {data} = await apiCheckout.addGoodies(payload);
            //console.log('promisse then', response);
            if(data.hasOwnProperty('cart')){
                // commit new cart data (root module)
                context.commit('cart', data.cart, { root: true });
            }
            // change loading state
            context.commit('isLoading', false, { root: true });
        },
        showProductsModal(context, payload){
            context.commit('showProductsModal', payload);
        },
    },
    getters: {
        showProductsModal: state => state.showProductsModal,
    },
};

export default goodies;